import { loadRecaptchaScript, needsRecaptchaScript } from '../utils/loadRecaptcha'
import { RECAPTCHA_SITE_KEY } from '../env'

export const recaptchaLoadMixin = {
  data () {
    return {
      recaptchaScriptReady: false
    }
  },
  mounted () {
    if (!needsRecaptchaScript(RECAPTCHA_SITE_KEY)) {
      return
    }
    loadRecaptchaScript()
      .then(() => {
        this.recaptchaScriptReady = true
      })
      .catch(() => {})
  },
  computed: {
    showRecaptchaWidget () {
      return needsRecaptchaScript(RECAPTCHA_SITE_KEY) && this.recaptchaScriptReady
    }
  }
}
